'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isNumber = {};

exports.__exports = isNumber;
